import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { createContext, memo, ReactNode, useContext, useState } from "react";

const OpenWithdrawalsOnboardingContext = createContext<
  (() => void) | undefined
>(undefined);

const WithdrawalsOnboardingRequestContext = createContext(0);

export const WithdrawalsOnboardingTriggerProvider = memo(
  function WithdrawalsOnboardingTriggerProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const [requestId, setRequestId] = useState(0);
    const open = useHandler(() => {
      setRequestId((current) => current + 1);
    });

    return (
      <OpenWithdrawalsOnboardingContext.Provider value={open}>
        <WithdrawalsOnboardingRequestContext.Provider value={requestId}>
          {children}
        </WithdrawalsOnboardingRequestContext.Provider>
      </OpenWithdrawalsOnboardingContext.Provider>
    );
  },
);

export function useOpenWithdrawalsOnboarding() {
  return useRequiredContext(OpenWithdrawalsOnboardingContext);
}

export function useWithdrawalsOnboardingRequestId() {
  return useContext(WithdrawalsOnboardingRequestContext);
}
